import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import Header from "../components/Header";
import { useLocation } from 'react-router-dom';
import Footer from "../components/Footer";
import "../styles/select-plan.scss";
import CTAButton from "../components/LandingPage/Common/CTAButton";
import { sendAnalyticsEvent } from '../utils/SendAnalyticsEvent';

function ExistingCustomer() {
    document.title="iWantTFC - Discover | Already Subscribed";
    const location = useLocation();
    const params = location.state;

    useEffect(() => {
        const eventProperties = {
            changePlanNotAllowedMessage: "Paying",
            paymentMethodType: params?.pm
        };
        sendAnalyticsEvent("changePlanNotAllowedRender", eventProperties, "Purchase Journey", "Discover page");
    }, []);

    return (
        <div className="body" style={{ backgroundImage: 'url(' + process.env.PUBLIC_URL + '/images/footer-bg.png)' }}>
            <Header />
            <div className="ec-container">
                <div className="text-container">
                    <p>You are currently enjoying an active paid subscription. Should you choose to change or upgrade your plan for greater savings, you may do so at the end of your current subscription period. For assistance, email <Link to="mailto:support@iwantTFC.com">support@iwantTFC.com</Link>.</p>
                </div>
                {params?.pm &&
                    <p className="label">Current payment method</p>
                }
                <p className="pm">{params?.pm}</p>
                <CTAButton link={process.env.REACT_APP_IWANTTFC_HOMEPAGE} text="Back to Home" />
            </div>

            <Footer bg="false" />
        </div>
    );
}

export default ExistingCustomer;